import React from "react";
import type { TypeLoaderProps } from "./LoaderTypes";
import LoaderHybrid from "./LoaderHybrid";

/**
 * Loader component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Loader = React.forwardRef<HTMLDivElement, TypeLoaderProps>(
  (props, ref) => <LoaderHybrid {...props} ref={ref} />
);

Loader.displayName = "Loader";
export default Loader;
